import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { apiService } from "../services/api";

export default function EditProfile() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [firstName, setFirstName] = useState(user?.firstName ?? "");
  const [lastName, setLastName] = useState(user?.lastName ?? "");
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState<{ type: "ok" | "err"; text: string } | null>(null);

  const save = async () => {
    setSaving(true);
    setMsg(null);
    try {
      await apiService.updateProfile({ firstName: firstName.trim(), lastName: lastName.trim() });
      setMsg({ type: "ok", text: "Profile updated" });
      setTimeout(() => navigate(-1), 700);
    } catch (e: any) {
      setMsg({ type: "err", text: e?.response?.data?.message || e?.message || "Update failed" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-white dark:bg-black text-black dark:text-white transition-colors duration-300">
      <div className="max-w-xl mx-auto px-5 pt-6">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white mb-6 transition-colors">
          <ChevronLeft size={20} /> Back
        </button>
        <h1 className="text-2xl font-semibold mb-6 font-['Caviar_Dreams']">Edit Profile</h1>

        <label className="block text-sm text-gray-600 dark:text-gray-400 mb-1 font-['Product_Sans']">First name</label>
        <input
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          className="w-full mb-4 px-4 py-3 rounded-xl bg-gray-50 dark:bg-white/5 border border-gray-300 dark:border-white/10 focus:border-blue-500 outline-none text-black dark:text-white"
        />
        <label className="block text-sm text-gray-600 dark:text-gray-400 mb-1 font-['Product_Sans']">Last name</label>
        <input
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          className="w-full mb-4 px-4 py-3 rounded-xl bg-gray-50 dark:bg-white/5 border border-gray-300 dark:border-white/10 focus:border-blue-500 outline-none text-black dark:text-white"
        />
        <label className="block text-sm text-gray-600 dark:text-gray-400 mb-1 font-['Product_Sans']">Email</label>
        <input
          value={user?.email ?? ""}
          disabled
          className="w-full mb-6 px-4 py-3 rounded-xl bg-gray-100 dark:bg-white/5 border border-gray-300 dark:border-white/10 text-gray-500 cursor-not-allowed"
        />

        {msg && (
          <div className={`mb-4 text-sm font-['Product_Sans'] ${msg.type === "ok" ? "text-green-600 dark:text-green-400" : "text-red-500 dark:text-red-400"}`}>
            {msg.text}
          </div>
        )}

        <button
          onClick={save}
          disabled={saving}
          className="w-full py-3 rounded-xl bg-blue-600 hover:bg-blue-500 disabled:opacity-50 font-semibold text-white transition-colors"
        >
          {saving ? "Saving…" : "Save Changes"}
        </button>
      </div>
    </div>
  );
}